/**
 * Lightweight i18n: UI strings are written in English and used as translation keys
 * (gettext style). Add a dictionary per language in `locales` to translate the interface.
 * Placeholders use {name} syntax: t('Hello {name}', { name }).
 */

type Dictionary = Record<string, string>;

const locales: Record<string, Dictionary> = {
  en: {},
};

let current: Dictionary = locales.en;
let currentLocale = 'en';

export function setLocale(locale: string): void {
  const base = locale.split('-')[0];
  currentLocale = locales[locale] ? locale : locales[base] ? base : 'en';
  current = locales[currentLocale];
  document.documentElement.lang = currentLocale;
}

export function getLocale(): string {
  return currentLocale;
}

export function availableLocales(): string[] {
  return Object.keys(locales);
}

export function t(key: string, vars?: Record<string, string | number>): string {
  const template = current[key] ?? key;
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (m, name: string) => (name in vars ? String(vars[name]) : m));
}

/** Plural helper: tn(count, '{n} document', '{n} documents'). */
export function tn(n: number, one: string, other: string): string {
  return t(n === 1 ? one : other, { n });
}
